import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveDisplayStatus, type DisplayStatusMeta } from '@/lib/domain';

export interface PaymentStatusPillProps {
  displayStatus: string | null | undefined;
  paymentId?: string;
}

/**
 * 결제 전용 displayStatus(payment `DisplayStatus`) — 주문 공용 맵에 없는 값. 종전엔 공용 맵만 봐서 환불 처리 후
 * (REFUNDED)·결제 취소·부분 환불·환불 실패가 모두 "알 수 없음"으로 보였다(QA-311). 나머지 값은 공용 맵을 그대로 쓴다.
 */
const PAYMENT_ONLY_META: Readonly<Record<string, DisplayStatusMeta>> = {
  PAYMENT_CANCELED: { i18nKey: 'status.PAYMENT_CANCELED', badge: 'neutral', icon: 'circle-slash' },
  PARTIALLY_REFUNDED: { i18nKey: 'status.PARTIALLY_REFUNDED', badge: 'warn', icon: 'rotate-ccw' },
  REFUNDED: { i18nKey: 'status.REFUNDED', badge: 'neutral', icon: 'rotate-ccw' },
  REFUND_FAILED: { i18nKey: 'status.REFUND_FAILED', badge: 'danger', icon: 'x-circle' },
};

export const PaymentStatusPill = ({ displayStatus, paymentId }: PaymentStatusPillProps) => {
  const { t } = useTranslation('payments');
  const meta =
    (displayStatus ? PAYMENT_ONLY_META[displayStatus] : undefined) ??
    resolveDisplayStatus(displayStatus, paymentId ? { orderId: paymentId, entity: 'payment' } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={displayStatus}
      label={t(meta.i18nKey, displayStatus ?? '')}
      testId="payment-status-pill"
    />
  );
};
